const video = {
	el: {
		body: document.querySelector('body'),
		modal: document.querySelector('.hero-video__modal'),
		videoContainer: document.querySelector('.js-video'),
		videoPlayerModal: document.querySelector('.hero-video__modal-video'),
		videoInlineContainer: document.querySelector('.js-video-container')
	},

	fxOpenModal() {
		this.el.modal.style.display = 'block'
		this.el.body.classList.add('no-scroll-fixed')
	},

	fxCloseModal() {
		this.el.modal.style.display = 'none'
		this.el.body.classList.remove('no-scroll-fixed')
	},

	fxPlayVideoInline(video) {
		video.parentElement.querySelector('video').play()
		video.parentElement.querySelector('video').controls = true
		video.style.display = 'none'
	},

	fxPlayVideoModal(video) {
		video.play()
	},

	fxStopVideoModal(video) {
		video.pause()
		video.currentTime = 0
	},

	events() {
		if (this.el.videoContainer) {
			const btnPlayInModal = this.el.videoContainer.querySelector('.js-play-video'),
				btnCloseModal = this.el.videoContainer.querySelector('.js-close-modal')

			btnPlayInModal.addEventListener('click', () => {
				this.fxOpenModal()
				this.fxPlayVideoModal(this.el.videoPlayerModal)
			})
			btnCloseModal.addEventListener('click', () => {
				this.fxStopVideoModal(this.el.videoPlayerModal)
				this.fxCloseModal()

			})
		}

		if (this.el.videoInlineContainer) {
			const btnPlayInline = this.el.videoInlineContainer.querySelector('.js-video-button-play')

			btnPlayInline.addEventListener('click', e => this.fxPlayVideoInline(e.currentTarget))
		}
	},

	init() {
		this.events()
	}
}

video.init()